import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { SearchBoxComponent } from 'components/accordion/search-widget/search-box/search-box.component';
import { DropdownModule } from 'shared/components/dropdown/dropdown.module';
import { SearchService } from 'common/search/search.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatInputModule } from '@angular/material/input';
import { LoadingModule } from 'shared/components/loading/loading.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild(),
    FormsModule,
    NgbModule,
    DropdownModule,
    MatInputModule,
    LoadingModule
  ],
  providers: [
    SearchService
  ],
  declarations: [
    SearchBoxComponent
  ],
  exports: [
    SearchBoxComponent
  ]
})
export class SearchBoxModule {}
